/* eslint-disable max-classes-per-file */
export class ForbiddenError extends Error {
  constructor(message?: string) {
    const finalMessage = message || 'Unknown error'
    super(finalMessage)
    Object.setPrototypeOf(this, ForbiddenError.prototype)
  }
}

export class ServerError extends Error {
  constructor(message?: string) {
    super(`${message}`)
    Object.setPrototypeOf(this, ServerError.prototype)
  }
}

export class TimeoutError extends Error {
  constructor(message?: string) {
    super(`${message}`)
    Object.setPrototypeOf(this, TimeoutError.prototype)
  }
}

export class UnauthorizedError extends Error {
  constructor(message?: string) {
    super(`${message}`)
    Object.setPrototypeOf(this, UnauthorizedError.prototype)
  }
}

export class NotFoundError extends Error {
  constructor(message?: string) {
    super(`${message}`)
    Object.setPrototypeOf(this, NotFoundError.prototype)
  }
}
